var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTooltipSignUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_180_19",
    "data-name": "Component 180 \\u2013 19",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.475,
    height: 22.475,
    viewBox: "0 0 22.475 22.475",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5038",
    "data-name": "Path 5038",
    d: "M13.907,8.861a2.807,2.807,0,0,0-3.421,2.014.562.562,0,1,0,1.089.281,1.685,1.685,0,1,1,2.165,2.018,1.693,1.693,0,0,0-1.1,1.631v.706a.561.561,0,0,0,.562.561h0a.562.562,0,0,0,.561-.562V14.8a.581.581,0,0,1,.341-.566,2.807,2.807,0,0,0-.194-5.377ZM13.2,17.055a.7.7,0,1,0,.7.7A.7.7,0,0,0,13.2,17.055ZM13.237,2A11.237,11.237,0,1,0,24.475,13.237,11.237,11.237,0,0,0,13.237,2Zm0,21.351A10.114,10.114,0,1,1,23.351,13.237,10.114,10.114,0,0,1,13.237,23.351Z",
    transform: "translate(-2 -2)",
    fill: "#222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipSignUp);
export default __webpack_public_path__ + "static/media/tooltip-sign-up.679ee6e8a2e7eddc5f5aadaadb1f21cf.svg";
export { ForwardRef as ReactComponent };